if (typeof $ === 'function') {

  //Bootstrap custom file input
  $(document).ready(function () {
    bsCustomFileInput.init()
  });

  //search toggle
  $('#toggleSearch').on('click', function () {
    var html = $('html');
    if (html.is('.search__is_open')) {
      html.removeClass('search__is_open');
    }
    else {
      html.addClass('search__is_open');
      setTimeout(function () {
        $('#s').focus();
      }, 100);
    }
    return false;
  });
  $(document).on('keyup', function (e) {
    if ($('html').is('.search__is_open') && e.which === 27) {
      $('#toggleSearch').trigger('click');
    }
  });


  //ypsilonka forms
  var cityRadios = $('#form_radios input[type="radio"]'),
      cityRadio = cityRadios.last(),
      cityBlock = $('#form_city');

  cityRadios.on('change click', function () {
    if (cityRadio.is(':checked')) {
      cityBlock.fadeIn(200).find('input').prop('disabled', false).removeAttr('disabled');
    }
    else {
      cityBlock.fadeOut(200).find('input').prop('disabled', true).attr('disabled', 'disabled');
    }
  }).trigger('change');



}
/*
TODO

 // FORMS
 // --------
 $('form:not([novalidate]) [type="submit"]')
     .on('click', function () {
         $(this).closest('form').addClass('validate');
     })
     .closest('form')
         .on('submit', function () {
             var t = $(this);
             if (typeof this.checkValidity === 'function' && this.checkValidity() === false) {
                 alert(__('Some mandatory fields are empty or in invalid format'));
                 t.find('[type="submit"]').removeClass('disabled ff-submitting').prop('disabled', false);
                 return false;
             }
             t.removeClass('validate');
         });
 // custom checkboxes
 $('.checkbox > label > input').after('<span class="custom-box trans"><span class="icon cfico-check4" /></span>');
 //touch checkbox helper
 //-------------------------
 $('.radios > .checkbox > label').on( 'click focus touchstart', function () {
     if ( $(window).width() >= 992 ) return;
     var checkbox = $(this).find('input[type="checkbox"]');
     checkbox.closest('.noselect').removeClass('noselect');
     if ( !checkbox.is(':checked') ) {
         checkbox.attr('checked','checked').prop('checked',true);
     }
 } );
 //passwords match
 $('form:not([novalidate]) [type="submit"]').closest('form').each(function () {
     if (typeof this.checkValidity === 'function') {
         var t = $(this),
             f1 = t.find('.password-match-1'),
             f2 = t.find('.password-match-2');
         if (!f1.length || !f2.length) return true;
         f1.add(f2).on('change keyup focus blur', function () {
             if (f1.val() != f2.val()) {
                 f2[0].setCustomValidity(__('Passwords do not match'));
             } else {
                 f2[0].setCustomValidity('');
             }
         });
     }
 });

//zavinac
$('input[type="email"]').not('.has_zavinac').not('[disabled],[readonly],.disabled')
    .addClass('has_zavinac')
    .after('<button class="btn btn-link do_zavinac" type="button" title="' + __('Insert @ character') + '">@</button>');
$(document).on('click', '.do_zavinac', function () {
    var b = $(this),
        i = b.closest('div').find('input').first();
    if (b.data('target')) i = b.closest('form').find(b.data('target'));
    if (!/@/.test(i.val())) {
        i.val( i.val() + '@' );
    }
    b.blur();
    i.focus();
    return false;
});
$(document).on('change mouseup keyup focus blur', 'input', function () {
    var i = $(this),
        b = i.closest('div').find('.do_zavinac');
    if (/@/.test(i.val())) {
        b.css('opacity',0);
    } else {
        b.css('opacity',1);
        b.blur();
    }
});
$('.has_zavinac').trigger('change');

*/
